import React from'react';import PropTypes from'prop-types';import Dotdotdot from'react-dotdotdot';/**
 * The ellipsis text component.
 * @param {Object} props The component props.
 * @returns {JSX}
 */var Ellipsis=function Ellipsis(props){return React.createElement(Dotdotdot,{clamp:props.rows,ellipsis:props.ellipsis,className:props.className,useNativeClamp:true},props.children);};Ellipsis.defaultProps={className:'',ellipsis:'...',rows:3};export default Ellipsis;